var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.labelInsideTextarea
    ? _c("div", { staticClass: "custom-textarea" }, [
        _vm.label
          ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
          : _vm._e(),
        _vm._v(" "),
        _c("textarea", {
          attrs: { placeholder: _vm.placeholder, disabled: _vm.disabled },
          domProps: { value: _vm.value },
          on: {
            input: function(event) {
              return this$1.$emit("update", event.target.value)
            }
          }
        })
      ])
    : _c(
        "md-field",
        { class: ["input", { "md-invalid": _vm.errors.length }] },
        [
          _vm.label
            ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "md-textarea",
            _vm._b(
              {
                attrs: {
                  value: _vm.value,
                  placeholder: _vm.placeholder,
                  disabled: _vm.disabled
                },
                on: { input: _vm.onChange }
              },
              "md-textarea",
              _vm.inputProps,
              false
            )
          ),
          _vm._v(" "),
          _vm._l(_vm.errors, function(error) {
            return _vm.errors.length
              ? _c("span", { staticClass: "md-error" }, [
                  _vm._v("\n    " + _vm._s(_vm.$t("errors." + error)) + "\n  ")
                ])
              : _vm._e()
          })
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }